import { useThemeContext } from "../Context/useThemeContext";

export const useTheme = useThemeContext;
